module.exports = __webpack_public_path__ + "static/media/download.c64b95ab.svg";